function noop(): void {
  /* intentionally left blank */
}

export default noop;
